module.exports = __webpack_public_path__ + "img/ru.3c40cd34.svg";